import * as React from 'react';
import { CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButtonWhiteBg from '../IconButtonWhiteBg';

interface RefreshButtonProps {
  isLoading: boolean;
  onClick: () => void;
  cypressId: string;
  disabled: boolean;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  isLoading,
  onClick,
  cypressId,
  disabled,
}) => {
  return (
    <IconButtonWhiteBg
      disabled={disabled}
      onClick={() => onClick()}
      id={cypressId}
      cypressId={cypressId}
      tooltip="Refresh"
    >
      {
        isLoading ? (
          <CircularProgress size={14} sx={{ color: '#5f6d7e' }} />
        ) : (
          <RefreshIcon sx={{ fontSize: 13, color: 'black' }} />
        )
      }
    </IconButtonWhiteBg>
  );
};

export default RefreshButton;
